module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABXBAMAAAAAIv1kAAAAHlBMVEUpIAuzji/4xUH0lj7tKTkAAAColiz64EL2oj/tKTmzIF9tAAAABXRSTlP++vjs1BQWlgsAAAA0SURBVHgBYmRAA4yKaAJCAugqQgHtyzENAAAAAiD7pzaDr4MfRVEURVEURVEURVGUr5K5FKE5M63dCLx6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/be.png
// module id = FCn3
// module chunks = 0